import React, { Component } from 'react';
import { MDBBtn, MDBAlert } from 'mdb-react-ui-kit';
import { Formik, Field, ErrorMessage, Form } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const resetPasswordValidationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required('New password is required')
    .trim('The password cannot include leading and trailing spaces')
    .strict(true)
    .min(8, 'The password needs to be at least 8 characters long')
    .matches(/.*[!@#$%^&*()]+.*/, 'Password must contain at least 1 special character (!@#$%^&*())')
    .matches(/.*[0-9].*/, 'Password must contain at least 1 digit')
    .matches(/(.*[A-z]){3,}/, 'Password must contain at least 3 letters'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], "Passwords don't match!")
    .required('Confirm password is required'),
});

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values, { setStatus }) {
    this.props.onResetPasswordClick(values, setStatus);
  }

  render() {
    return (
      <Formik
        initialValues={{
          newPassword: '',
          confirmPassword: '',
        }}
        onSubmit={this.handleSubmit}
        validationSchema={resetPasswordValidationSchema}
      >
        {({ status, errors, touched, submitCount }) => (
          <Form>
            {status && status.api_error_message && (
              <MDBAlert open color="danger">
                {status.api_error_message}
              </MDBAlert>
            )}
            {status === false && submitCount > 0 && (
              <MDBAlert open color="danger">
                Something went wrong. Please try again.
              </MDBAlert>
            )}
            {status && status.success_message && (
              <MDBAlert open color="success">
                {status.success_message}
              </MDBAlert>
            )}
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="newPassword" style={{ display: 'block' }}>
                New Password <sup>*</sup>
              </label>
              <Field type="password" name="newPassword" className="form-control" />
              <ErrorMessage name="newPassword" className="error" component="div" />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="confirmPassword" style={{ display: 'block' }}>
                Confirm Password <sup>*</sup>
              </label>
              <Field type="password" name="confirmPassword" className="form-control" />
              <ErrorMessage name="confirmPassword" className="error" component="div" />
            </div>
            {touched.newPassword && Object.keys(errors).length === 0 ? (
              <MDBBtn
                gradient="blue"
                type="submit"
                className="btn-block z-depth-2"
                style={{ marginTop: '20px', marginLeft: '0px' }}
              >
                Update Password
              </MDBBtn>
            ) : (
              <MDBBtn
                gradient="blue"
                type="submit"
                className="btn-block z-depth-2"
                style={{ marginTop: '20px', marginLeft: '0px' }}
                disabled
              >
                Update Password
              </MDBBtn>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

ResetPasswordForm.propTypes = {
  onResetPasswordClick: PropTypes.func,
};

export default ResetPasswordForm;
